import { useCallback, useEffect, useRef } from "react";

const useBackButtonHandler = () => {
  const listenerRef = useRef<BackButtonListener | null>(null);

  const registerBackButtonListener = useCallback(
    (listener: BackButtonListener) => {
      if (listenerRef.current) {
        const index = backButtonListeners.indexOf(listenerRef.current);
        if (index !== -1) {
          backButtonListeners.splice(index, 1);
        }
      }

      listenerRef.current = listener;
      backButtonListeners.push(listener);

      return () => {
        const index = backButtonListeners.indexOf(listener);
        if (index !== -1) {
          backButtonListeners.splice(index, 1);
        }
        listenerRef.current = null;
      };
    },
    []
  );

  useEffect(() => {
    return () => {
      if (listenerRef.current) {
        const index = backButtonListeners.indexOf(listenerRef.current);
        if (index !== -1) {
          backButtonListeners.splice(index, 1);
        }
      }
    };
  }, []);

  return {
    registerBackButtonListener,
  };
};

export default useBackButtonHandler;

export const shouldBlockNavigation = (): boolean => {
  return backButtonListeners.some((listener) => listener());
};

type BackButtonListener = () => boolean;
const backButtonListeners: BackButtonListener[] = [];
